<template>
  <b-overlay :show="loading" opacity="0.8">
    <validation-observer ref="form_ref" #default="">
      <b-card class="rounded-lg">
        <template #header>
          <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
            <h4 class="text-dark m-0">
              Treatment Advice
            </h4>
          </div>
        </template>

        <validation-observer #default="{ handleSubmit }" ref="update_modal_form">
          <b-form @submit.prevent="handleSubmit(onUpdate)">
            <div class="no-body">
              <validation-provider #default="validationContext" name="" rules="">
                <b-form-group label="">
                  <b-form-textarea
                    id="treatment_advice"
                    v-model="treatment_advice"
                    rows="15"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />
                  
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BOverlay,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormTextarea,
  BFormInvalidFeedback,
} from 'bootstrap-vue'


import { heightTransition } from '@core/mixins/ui/transition';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BFormGroup,
    BFormTextarea,
    BDropdownItem,
    BFormInvalidFeedback,

    // validations
    ValidationProvider,
    ValidationObserver
  },
  mixins: [heightTransition],
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      treatment_advice: this.consultationData.treatment_advice
    }
  },
  computed: {
    disableForm(){
      return true
    },
  },
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}

#treatment_advice:disabled {
  background-color: transparent !important; 
}
</style>
